module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-light-gray-51729ccacd286acefb5c9027ece79632.png";